
import { Options, Prop, Vue } from 'vue-property-decorator'

import RtlPlus from '../icons/RtlPlus.vue'

@Options({
  name: 'UefaUpcomingList',
  components: {
    RtlPlus
  }
})
export default class UefaUpcomingList extends Vue {
  @Prop({
    type: Array,
    default: () => []
  })
  readonly contents!: Array<{
    items: Array<{
      name: string
      logo: string
    }>
    date: Date
    url: string
  }>

  @Prop({
    type: Boolean,
    default: false
  })
  readonly showSlider!: boolean

  @Prop({
    type: Number,
    default: 0
  })
  readonly cols!: number
}
